const initPrimaryNavigation = (navLinks, sectionEls) => {
    // console.log( 'primaryNavigation init triggered' );
    navLinks.forEach( navLink => navLink.addEventListener('keydown', navLinkKeyPress) )
    sectionEls.forEach( section => section.addEventListener('keydown', sectionElKeyPress) )
}

const destroyPrimaryNavigation = (navLinks, sectionEls) => {
    // console.log( 'primaryNavigation destroy triggered' );
    navLinks.forEach( navLink => navLink.removeEventListener('keydown', navLinkKeyPress) )
    sectionEls.forEach( section => section.removeEventListener('keydown', sectionElKeyPress) )
}

const initMobileNavigation = (navMenu) => {
    // console.log( 'mobileNavigation init triggered' );
    navMenu.addEventListener('keydown', mobileNavKeyPress)
}

const destroyMobileNavigation = (navMenu) => {
    // console.log( 'mobileNavigation destroy triggered' );
    navMenu.removeEventListener('keydown', mobileNavKeyPress)
}

const navLinkKeyPress = (event) => {
    if (event.keyCode == 37) { // left arrow 
        event.preventDefault();
        // console.log('left arrow key pressed');
    } else if (event.keyCode == 38) { // up arrow 
        event.preventDefault();
        // console.log('up arrow key pressed');
    } else if (event.keyCode == 39) { // right arrow 
        event.preventDefault();
        // console.log('right arrow key pressed');
    } else if (event.keyCode == 40) { // down arrow 
        event.preventDefault();
        // console.log('down arrow key pressed');
        // let target = event.target.getAttribute('data-target');
        // event.target.classList.add('active');
        const siblings = event.target.parentNode.childNodes;
        for ( let i = 0; i < siblings.length; i++ ) {
          if ( siblings[i].tagName == 'UL' && siblings[i].classList.contains('sub-menu') ) {
            const sectionEl = showSection(siblings[i]);
            let focusableChildren = getFocusableChildren(sectionEl);
            if ( focusableChildren.length > 0 ) {
                focusableChildren[0].focus();
            } 
            break;
          }
        }
    }
}

const sectionElKeyPress = (event) => {
    const section = event.target.closest('#nav-wrapper .c-mainnav > .menu-item-has-children > .sub-menu');
    if (event.key === 'Tab') { // tab 
        event.preventDefault();
        if (event.shiftKey) {
            focusPrevChildElement(section);
        } else {
            focusNextChildElement(section);
        }
    }
    if (event.keyCode == 27) { // escape arrow 
        event.preventDefault();
        const siblings = section.parentNode.childNodes;
        for ( let i = 0; i < siblings.length; i++ ) {
          if ( siblings[i].tagName == 'A' ) {
            siblings[i].focus();
            hideSection();
            break;
          }
        }
    }
}

const mobileNavKeyPress = (event) => {
    const body = document.getElementsByTagName("body")[0],
          navToggle = document.getElementById('nav-toggle'),
          navMenu = document.querySelector('#nav-content');

    if (event.key === 'Tab') { // tab 
        event.preventDefault();
        if (event.shiftKey) {
            focusPrevChildElement(navMenu);
        } else {
            focusNextChildElement(navMenu);
        }
    }
    if (event.keyCode == 27) { // escape arrow 
        event.preventDefault();
        navToggle.focus();
        navMenu.classList.add('hidden');
        body.classList.remove('overflow-hidden');
    }
}

const showSection = (section) => {
    const sectionEls = document.querySelectorAll('#nav-wrapper .c-mainnav > .menu-item-has-children > .sub-menu');

    sectionEls.forEach( el => el.classList.remove('active' ) );
    section.classList.add('active');
    return section;
}

const hideSection = () => {
    const sectionEls = document.querySelectorAll('#nav-wrapper .c-mainnav > .menu-item-has-children > .sub-menu');

    // navLinks.forEach( el => el.classList.remove('active') );
    sectionEls.forEach( el => el.classList.remove('active') );
}

const getFocusableChildren = (selector) => {
    const focusableChildren = selector.querySelectorAll('button:not([disabled]), [href]:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])');
    return focusableChildren;
}

const focusPrevChildElement = (selector) => {
    if (document.activeElement) {
        var focusable = Array.prototype.filter.call(
            getFocusableChildren(selector),
            function (element) {
                //check for visibility while always include the current activeElement
                return (
                    element.offsetWidth > 0 ||
                    element.offsetHeight > 0 ||
                    element === document.activeElement
                );
            }
        );
        var index = focusable.indexOf(document.activeElement);
        if (index > -1) {
            var prevElement = focusable[index - 1] || focusable[(focusable.length - 1)];
            prevElement.focus();
        }
    }
}

const focusNextChildElement = (selector) => {
    if (document.activeElement) {
        var focusable = Array.prototype.filter.call(
            getFocusableChildren(selector),
            function (element) {
                //check for visibility while always include the current activeElement
                return (
                    element.offsetWidth > 0 ||
                    element.offsetHeight > 0 ||
                    element === document.activeElement
                );
            }
        );
        var index = focusable.indexOf(document.activeElement);
        if (index > -1) {
            var nextElement = focusable[index + 1] || focusable[0];
            nextElement.focus();
        }
    }
}

window.addEventListener('DOMContentLoaded', () => {
    const body = document.getElementsByTagName("body")[0],
          navMenu = document.querySelector('#nav-content'),
          navLinks = document.querySelectorAll('#nav-wrapper .c-mainnav > .menu-item-has-children > a'),
          sectionEls = document.querySelectorAll('#nav-wrapper .c-mainnav > .menu-item-has-children > .sub-menu');
    
    let primaryNavInitExecuted = false;
    let mobileNavInitExecuted = false;

    // Initialize resize observer object
    let resizeObserver = new ResizeObserver(() => {
        if ( window.innerWidth >= 1024 ) {
            // console.log( 'Desktop viewport' );
            
            if (mobileNavInitExecuted) {
                destroyMobileNavigation(navMenu);
                mobileNavInitExecuted = false;
            }

            if (!primaryNavInitExecuted) {
                initPrimaryNavigation(navLinks, sectionEls);
                primaryNavInitExecuted = true;
            }

        } else {
            // console.log( 'Tablet/mobile viewport' );

            if (primaryNavInitExecuted) {
                destroyPrimaryNavigation(navLinks, sectionEls);
                primaryNavInitExecuted = false;
            }

            if (!mobileNavInitExecuted) {
                initMobileNavigation(navMenu);
                mobileNavInitExecuted = true;
            }
        }
    });
     
    // Add a listener to body
    resizeObserver.observe(body);
})
